export const NEEDS_REQUIRED_MESSAGE = "필요한 것을 하나 이상 골라 주세요";
export const PLAN_INTEREST_FAILED_MESSAGE = "신청하지 못했습니다. 잠시 후 다시 시도하세요.";
